export default {
  title: 'Annuaire des professionnels',
  subtitle: 'Liste des professionnels de santé renseignés',
  search: 'Rechercher un professionnel',
  personnalInformations: 'Informations personnelles',
  professionalInfoDisplay: {
    title: 'Fiche d\'informations du professionnel',
    generalInformations:'Informations générales',
    professionnalInformations:'Informations professionnelles',
    job:'Profession',
    expertise: 'Expertise',
    speciality:'Spécialité',
    establishment:'Établissement',
    coordinates: 'Coordonnées',
    phone:'Téléphone',
    mail:'Mail',
    location:'Lieu d\'exercice',
    contact:'Contact'
  },
  columns: {
    professional: 'Professionnel',
    skills: 'Compétences',
    contact: 'Contact',
    actions: 'Actions'
  },
  close:{
    filters:'Fermer les filtres',
    search: 'Fermer la recherche'
  },
  filters:{
    job: 'Profession',
    skills: 'Compétences'
  },
  referent: 'Référent',
  proReferent : 'Professionnel référent',
  professionalList: {
    noEntry:'Aucun professionel.',
    noSpecialty:'Pas de spécialité',
    noProfession:'Pas de profession'
  },
  contact: {
    phone: 'Contacter par téléphone',
    mail: 'Contacter par mail'
  },
  errors: {
    fetchProfessionals: 'Erreur lors de la récupération des professionnels',
    fetchBySearch: 'Erreur lors de la récupération des professionnels PAR RECHERCHE',
    fetchBySkills: 'Erreur lors de la récupération des professionnels PAR SKILLS:',
    fetchByJob: 'Erreur lors de la récupération des professionnels PAR PROFESSION:',
    fetchSkills: 'Erreur lors de la récupération des skills:'
  },
  professions: {
    dentalAssistant: 'Assistant dentaire',
    socialAssistant: 'Assistant social',
    audioProsthetist: 'Audio-prosthétiste',
    chiropractor: 'Chiropracteur',
    dentalSurgeon: 'Chirurgien-dentiste',
    dietician: 'Diététicien',
    epithesist: 'Épithésiste',
    ergotherapist: 'Ergothérapeute',
    nurse: 'Infirmier',
    ermManipulator: 'Manipulateur ERM',
    physiotherapist: 'Masseur-Kinésithérapeute',
    doctor: 'Médecin',
    oculist: 'Oculiste',
    optician: 'Opticien-lunetier',
    speechTherapist: 'Orthophoniste',
    orthopaedist: 'Orthopédiste',
    orthoprosthetist: 'Orthoprothesiste',
    orthotist: 'Orthopédiste-Orthésiste',
    osteopath: 'Ostéopathe',
    pharmacist: 'Pharmacien',
    medicalPhysist: 'Physicien médical',
    podiatrist: 'Podo-Orthésiste',
    nonPS: 'Profession non PS',
    psychologist: 'Psychologue',
    psychomotrician: 'Psychomotricien',
    psychotherapist: 'Psychothérapeute',
    chiropodist: 'Pédicure-Podologue',
    midwife: 'Sage-femme',
    laboratoryTechnician: 'Technicien de Laboratoire'
  }
}
